import React from 'react';
import styled from 'styled-components';
import { colors } from '../utils/colors';

const Tituloh1 = styled.h1`
   color: ${colors.white};
   padding-top: .2em;
   font-weight: 700;
   font-family: 'D-Din', sans-serif;
   font-size: 3.2em;
   line-height: .9em;
`;

const Titulo = ({ contenido }) => (
	<div>
      <Tituloh1>{contenido}</Tituloh1>
	</div>
);

export default Titulo;



// WEBPACK FOOTER //
// ./src/components/Titulo.js